import { LinksConfiguration, LinkItem } from '../types/links';
import { 
  DynatraceIcon,
  AzurePortalIcon,
  AzureDevOpsIcon,
  SonarCloudIcon,
  PowerBIIcon,
  ServiceNowIcon,
  ConfluenceIcon,
  JiraIcon
} from '../components/icons';

export const linksConfiguration: LinksConfiguration = {
  links: [
    {
      id: 'dynatrace',
      title: 'Dynatrace',
      description: 'Intelligent observability platform that enables real-time monitoring of applications, infrastructure, and user experience.',
      url: 'https://xyc10065.apps.dynatrace.com/ui/apps/dynatrace.launcher/getting-started',
      category: 'Monitoring',
      icon: DynatraceIcon,
      keywords: ['observability', 'monitoring', 'applications', 'infrastructure', 'performance'],
    },
    {
      id: 'azure-portal',
      title: 'Azure Portal',
      description: 'Main Microsoft Azure portal for managing cloud resources, services, and enterprise applications.',
      url: 'https://portal.azure.com',
      category: 'Cloud',
      icon: AzurePortalIcon,
      keywords: ['azure', 'cloud', 'microsoft', 'resources', 'cloud'],
    },
    {
      id: 'azure-devops',
      title: 'Azure DevOps',
      description: 'Collaborative development platform with Git repositories, CI/CD pipelines, and project management.',
      url: 'https://dev.azure.com/BancoPichinchaEC',
      category: 'Development',
      icon: AzureDevOpsIcon,
      keywords: ['devops', 'git', 'ci/cd', 'pipelines', 'repositories', 'development'],
    },
    {
      id: 'sonarcloud',
      title: 'SonarCloud',
      description: 'Code quality analysis platform that identifies bugs, vulnerabilities, and code smells in real-time.',
      url: 'https://sonarcloud.io/login',
      category: 'Development',
      icon: SonarCloudIcon,
      keywords: ['code', 'quality', 'bugs', 'vulnerabilities', 'development'],
    },
    {
      id: 'kpicoeingenieria',
      title: 'Engineering COE Metrics',
      description: 'Corporate dashboard with business metrics, KPIs, and real-time executive reports.',
      url: 'https://app.powerbi.com/groups/me/reports/c636c2b8-3186-4519-bc0c-4e4886f09b69/bffe8bd5865aeb5b5b36?ctid=f5b0d682-1497-4db0-9019-660035554e72&experience=power-bi',
      category: 'Analytics',
      icon: PowerBIIcon,
      keywords: ['metrics', 'kpis', 'reports', 'dashboard', 'analytics', 'business'],
    },
    {
      id: 'servicenow',
      title: 'ServiceNow',
      description: 'IT service management platform for tickets, incidents, and change requests.',
      url: 'https://pichinchaec.service-now.com',
      category: 'ITSM',
      icon: ServiceNowIcon,
      keywords: ['tickets', 'incidents', 'itsm', 'services', 'support'],
    },
    {
      id: 'confluence',
      title: 'Confluence',
      description: 'Collaborative platform for technical documentation, knowledge bases, and corporate wikis.',
      url: 'https://pichincha.atlassian.net/wiki/home',
      category: 'Documentation',
      icon: ConfluenceIcon,
      keywords: ['documentation', 'wiki', 'confluence', 'knowledge', 'collaboration'],
    },
    {
      id: 'jira',
      title: 'Jira',
      description: 'Agile project management tool for issue tracking and sprint planning.',
      url: 'https://pichincha.atlassian.net/jira/projects',
      category: 'Management',
      icon: JiraIcon,
      keywords: ['jira', 'projects', 'agile', 'scrum', 'issues', 'sprints'],
    }
  ]
};
